import { Observable, ReplaySubject, BehaviorSubject } from "rxjs";
import { take } from "rxjs/operators";
import { getSaleTypeForm } from "../api";

let hash = require('object-hash');

let $payloadToGetPackageCreationInfo = new ReplaySubject(1);

let saleTypeList = {};
let $saleTypeListUpdate = new BehaviorSubject({ ...saleTypeList });

export const createSaleTypePayload = (packageInfo) => {
    const IDCOMBOS = Object.keys(packageInfo).filter((key) =>
        key.match(/IDCOMBO/gi)
    );
    const CLIENTIDS = Object.keys(packageInfo).filter((key) =>
        key.match(/CLIENTID/gi)
    );

    let payload = {
        USERID: packageInfo.USERID,
        ROLEID: packageInfo.ROLEID,
        CLIENTID: 1,
        SUBCLIENTID: 1,
    };

    CLIENTIDS.forEach((CLIENTID) => {
        payload[CLIENTID] = packageInfo[CLIENTID];
    });
    IDCOMBOS.forEach((IDCOMBO) => {
        payload[IDCOMBO] = packageInfo[IDCOMBO];
    });

    return payload;
};

export const createSaleTypePayloadHash = (packageInfo) => {
    const saleTypePayload = createSaleTypePayload(packageInfo);
    return hash(saleTypePayload, { unorderedObjects: true });
};

const getSaleType = (payload) => {
    return new Observable(subscriber => {
        getSaleTypeForm(payload)
            .then(response => {
                subscriber.next(response);
                subscriber.complete();
            })
            .catch(error => {
                subscriber.error(error);
            });

        return () => {
            subscriber.complete();
        };
    });
};

export const selectOption = (name, props) => {
    return function(option) {
        return Object.keys((option || {})).includes((props[name] || "").toString(10));
    };
};

const PENDING = Symbol('PENDING');

export const DataService = {
    getPayloadToRetrieveFormInfo: () => $payloadToGetPackageCreationInfo,
    setPayloadToRetrieveFormInfo: (payload) => {
        $payloadToGetPackageCreationInfo.next(payload);
    },
    resetPayloadSubject: () => {
        $payloadToGetPackageCreationInfo = new ReplaySubject(1);
    },
    setSaleTypeList: (payload) => {
        const payload_hash = createSaleTypePayloadHash(payload);

        const current = saleTypeList[payload_hash];
        if (current === PENDING || (current && current !== '')) return;

        saleTypeList[payload_hash] = PENDING;

        getSaleType(createSaleTypePayload(payload))
            .pipe(take(1))
            .subscribe({
                next: (response) => {
                    const saleTypeString = (response.fields || [])
                        .map((field) =>
                            (field.options || []).filter(selectOption(field.name, payload))
                        )
                        .map((option) => {
                            let value = Object.values(((option || []).pop() || {}));
                            value = (value || []).pop();
                            return value;
                        })
                        .join(' ');

                    if (saleTypeString) {
                        saleTypeList[payload_hash] = saleTypeString;
                    } else {
                        delete saleTypeList[payload_hash];
                    }

                    $saleTypeListUpdate.next({ ...saleTypeList });
                },
                error: (error) => {
                    console.error('Error obteniendo saleType:', error);
                    delete saleTypeList[payload_hash];
                    $saleTypeListUpdate.next({ ...saleTypeList });
                }
            });
    },

    getSaleTypeList: () => $saleTypeListUpdate,
    resetPayloadSubject: () => {
        $payloadToGetPackageCreationInfo = new BehaviorSubject(null);
    }
};